import { Outlet, Navigate } from 'react-router-dom';
import {jwtDecode} from 'jwt-decode';

function PrivateAdminRoutes() {
  const user = localStorage.getItem("userData");
  
  if (!user) {
    return <Navigate to="./login" />;
  }

  const userData = JSON.parse(user);

  try {
    const decodedToken = jwtDecode(userData.token);
    // console.log(decodedToken)


    
    return decodedToken ? <Outlet /> : <Navigate to="./login" />;
  } catch (error) {
    console.log("No")
    console.error('Token decoding error:', error);
    return <Navigate to="/login" />;
  }
}

export default PrivateAdminRoutes;
